import styled from 'styled-components';

import { theme } from '../../common/ui/theme';
import { Text } from '../Text/Text';

const Frame = styled.div<{ $size: 'default' | 'small' }>`
    height: ${({ $size }) => ($size === 'small' ? theme.space[24] : theme.space[40])};
    width: ${({ $size }) => ($size === 'small' ? theme.space[24] : theme.space[40])};
    background-color: ${theme.colors.background.default};

    border-radius: ${theme.radii[6]};

    border-width: 1px;
    border-style: solid;
    border-color: ${theme.colors.border.muted};

    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`;

const AvatarImage = styled.img`
    width: 100%;
    height: 100%;
    padding: ${theme.space[2]};
    box-sizing: border-box;
    object-fit: contain;
`;

interface AvatarProps {
    imageUrl?: string;
    name: string;
    size?: 'default' | 'small';
}

export const Avatar = ({ imageUrl, name, size = 'default' }: AvatarProps) => {
    return (
        <Frame $size={size}>
            {imageUrl ? (
                <AvatarImage alt={name} src={imageUrl} />
            ) : (
                <Text variant={size === 'small' ? 'extraSmall' : 'subtitle1'}>{name.charAt(0)}</Text>
            )}
        </Frame>
    );
};
